"use client";

import { motion } from "framer-motion";
import { CreditCard, ShieldCheck, Rocket, LineChart } from "lucide-react";

const steps = [
  {
    num: "01",
    icon: CreditCard,
    title: "Choose Your Plan",
    desc: "Select the plan that matches your expected volume and support needs. Business for self-directed teams; Enterprise for hands-on project oversight.",
  },
  {
    num: "02",
    icon: ShieldCheck,
    title: "Subscribe Securely with Stripe",
    desc: "Sign up directly on the website using Stripe checkout. Secure, fast, and straightforward. No procurement delays.",
  },
  {
    num: "03",
    icon: Rocket,
    title: "Launch Your Workflow",
    desc: "We help structure your campaign objectives, call flows, and workflows so you're ready to go live with confidence.",
  },
  {
    num: "04",
    icon: LineChart,
    title: "Monitor and Optimize",
    desc: "Track performance, review results, and scale with the plan that best fits your usage. Enterprise clients receive dedicated oversight and optimization support.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="section-padding" style={{ background: "var(--color-bg)" }}>
      <div className="section-inner">
        <h2 className="section-heading">
          Simple setup.{" "}
          <em style={{ fontFamily: "var(--font-heading)" }}>Scalable execution.</em>
        </h2>
        <p className="section-subheading">
          From plan selection to campaign launch, getting started takes days, not months.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: 32,
          }}
        >
          {steps.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 16,
              }}
            >
              {/* Step number */}
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <span
                  style={{
                    fontFamily: "var(--font-heading)",
                    fontSize: "2.4rem",
                    color: "var(--color-border)",
                    lineHeight: 1,
                  }}
                >
                  {step.num}
                </span>
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background: "var(--color-bg-alt)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <step.icon size={20} color="var(--color-text)" strokeWidth={1.6} />
                </div>
              </div>
              <h3
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "1.2rem",
                  color: "var(--color-text)",
                }}
              >
                {step.title}
              </h3>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "var(--color-text-muted)",
                  fontWeight: 300,
                  lineHeight: 1.7,
                }}
              >
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
